import React from 'react';
import OccurrenceInfo from "./tables/occurrence-info.jsx";
import OccurrenceVehicle from "./tables/occurrence-vehicle.jsx";
import OccurrenceIndividual from "./tables/occurrence-individual.jsx";
import OccurrenceObjects from "./tables/occurrence-objects.jsx";
import OccurrenceLinks from "./tables/occurrence-links.jsx";
import OccurrenceCompanies from "./tables/occurrence-companies.jsx";
import OccurrenceAttaches from "./tables/occurrence-attaches.jsx";
import OccurrenceAnnotations from "./tables/occurrence-annotations.jsx";
import InfoGrid from "../../../../../components/info-grid/info-grid.jsx";
import OccurrenceReason from "./tables/occurrence-reason.jsx";

const ReportContent = ({data}) => {
    const occData = data.data ?? []

    return (
        <>
            <div className="space-y-4 mt-[-17px]! print:mt-[10px]! pb-5">
                <OccurrenceReason data={occData}/>

                <OccurrenceInfo key={'info'} data={data} occData={occData}/>

                <OccurrenceVehicle key={'vehicle'} data={occData}/>

                <OccurrenceIndividual key={'individual'} data={occData}/>

                <OccurrenceObjects key={'objects'} data={occData}/>

                <OccurrenceLinks key={'links'} data={occData}/>

                <OccurrenceCompanies key={'companies'} data={occData}/>

                <OccurrenceAnnotations key={'annotations'} data={occData}/>

                <OccurrenceAttaches key={'attaches'} data={occData}/>
            </div>
        </>
    );
};

export default ReportContent;